<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Абонементы</div>
            </div>
            <div class="panel-body pn">
                <per-pager v-bind:per-page="pagination.perPage"></per-pager>
                <table class="table table-striped table-hover datatables" id="clients_list" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Наменование</th>
                            <th>Количество</th>
                            <th>Стоимость</th>
                            <th>Срок действия</th>
                            <th>Дата создания</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(subscription, index) in subscriptions" v-bind:key="index">
                            <td>{{subscription.id}}</td>
                            <td>
                                <router-link :to="{name: 'subscriptions-edit', params: {id: subscription.id}}">
                                    {{subscription.name}}
                                </router-link>
                            </td>
                            <td>{{subscription.count}}</td>
                            <td>{{subscription.price}}</td>
                            <td>{{subscription.days}}</td>
                            <td>{{subscription.createdAt | dateFormatTimestamp('dd.mm.yyyy HH:MM:ss')}}</td>
                        </tr>
                    </tbody>
                </table>
                <paginator v-bind="pagination"></paginator>
            </div>
        </div>
    </div>
</template>

<script>
    import Subscription from "../../models/Subscription";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../data/Paginator'),
            PerPager: () => import('../data/PerPager'),
        },
        beforeMount() {
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.load();
        },
        data() {
            return {
                isLoading: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                subscriptions: [],
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
        },
        methods: {
            async load() {
                this.isLoading = true;
                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();

                const {data, headers} = await Subscription.getList(page, perPage, '-id');
                this.setData(data, headers);
                this.isLoading = false;
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['subscriptions-list']) {
                    return this.$store.state.template.perPages['subscriptions-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'subscriptions-list', value: value})
            },
            setData(subscriptions, headers) {
                this.subscriptions = subscriptions;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            }
        },
        metaInfo() {
            return {
                title: 'Абонементы - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
